import { Model } from 'src/app/model/model';
import { WIZ_EVENT_TYPE, WizMathUtils, VALUE_ENTER, VALUE_ESCAPE } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizValidationContainerDirective,
  WizTextInput,
  WizValidationErrors,
  WizFocusManager,
  WizTranslationBasic,
  WizDropdown,
  WizDatasource,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ChangeDetectorRef,
  ElementRef,
  HostListener
} from '@angular/core';
import { PhysicalTemplateVO, ViewData } from '@wizeoo/akm-common-lib';

/**
 * PopUp de création d'un template de widgets
 */
@Component({
  selector: 'phys-template-creation-pop',
  templateUrl: './phys-template.create.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhysicalTemplateCreationPop extends WizBasePopUp {
  /**
   * Référence à la directive de validation du container
   */
  @ViewChild(WizValidationContainerDirective, { read: WizValidationContainerDirective })
  private validationContainer: WizValidationContainerDirective;

  @ViewChild('tiCode', { read: WizTextInput, static: true }) tiCode: WizTextInput;
  @ViewChild('tiLabel', { read: WizTranslationBasic, static: true }) tiLabel: WizTranslationBasic;
  @ViewChild('taDescription', { read: WizTranslationBasic, static: true }) taDesc: WizTranslationBasic;
  @ViewChild('ddClone', { read: WizDropdown, static: true }) ddClone: WizDropdown;

  public templateDS: WizDatasource<PhysicalTemplateVO> = new WizDatasource<PhysicalTemplateVO>(Model.getInstance().physicalTemplateEngine.getVisionTemplates(Model.getInstance().visionCode))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .build(); // la collection de PhyTVO pour alimentation de la drop de clone


  private _template: PhysicalTemplateVO = new PhysicalTemplateVO(Model.getInstance()); // le template à créer

  private _isValidable: boolean = false; // Indique si la pop est validable
  public get isValidable(): boolean {
    return this._isValidable;
  }

  constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) {
    super();
  }

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER && this.isValidable) {
      this.validate();
    }
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  show() {
    this.tiCode.wizRestrict = ViewData.CODE_REGEXP;

    // initialisation de l'input de traduction du libellé
    this.tiLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this._template.labelVO);
    // initilisation de l'input de traduction de la description
    this.taDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(this._template.descriptionVO);

    // focus du premier champ
    if (this.tiCode) {
      WizFocusManager.getInstance().wizSetFocus(this.tiCode);
    }
    WizEventManager.addListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE, this.onModelUpdate);
  }

  hide(): void {
    WizEventManager.removeListener(this, this, WIZ_EVENT_TYPE.MODEL_UPDATE);
    super.hide();
  }

  /**
   * Méthode de la validation de la création. Alimentation des données du template
   */
  validate() {

    if (!!this.ddClone.selectedItem) {
      this._template = Model.getInstance().physicalTemplateEngine.CloneAndPersist(this.ddClone.selectedItem, this.tiCode.wizValue?.toUpperCase());
    } else {
      this._template.code = this.tiCode.wizValue?.toUpperCase();
      this._template.domain = Model.getInstance().domainCode;
      this._template.businessUnitCode = Model.getInstance().businessUnitCode;
      this._template.uid = WizMathUtils.createUUID();
      this._template.widgets = [];
      this._template.visionCode = Model.getInstance().visionCode; // this.visionDatasource.selectedItem.code;
    }

    this.tiLabel.entryDS.getSource().forEach((entry) => this._template.labelVO.updateTranslationEntry(entry));
    this.taDesc.entryDS.getSource().forEach((entry) => this._template.descriptionVO.updateTranslationEntry(entry));

    const errors: WizValidationErrors = this.validationContainer.check(false);
    this._isValidable = !errors || errors.length === 0;
    if (this.isValidable) {
      // merge de la création, envoie en BDD
      Model.getInstance().physicalTemplateEngine.merge(this._template, null, this.onPhyTCreated.bind(this));
    }
  }

  /**
   * Retour de création du template
   * @param phyT L'objet créé
   * @param status Le status de la demande de merge
   */
  onPhyTCreated(phyT: PhysicalTemplateVO, status: string) {
    // sur le retour, on appel la callbak est on ferme la pop
    if (!!this.callback) {
      this.callback(phyT);
    }
    this.hide();
  }

  /**
   * Sur mise à jour du model (des composants du formulaire)
   */
  onModelUpdate(e: WizEvent): void {
    const errors: WizValidationErrors = this.validationContainer.check(false);
    this._isValidable = !errors || errors.length === 0;
    this.cdref.markForCheck();
  }
}
